import Link from "next/link";

interface INavLinkProps {
  href: string;
  target: string;
  className?: string;
  linkText?: string;
  onClick?: () => void;
  pathname?: string;
}

export function NavLink({
  href,
  target,
  className,
  linkText,
  onClick,
  pathname,
}: INavLinkProps): React.ReactNode {
  return (
    <>
      {target === "_self" ? (
        <Link
          className={`${className || ""} whitespace-pre-wrap break-words`}
          href={`/${pathname}/${href}`}
          onClick={onClick}
        />
      ) : (
        <Link
          className={`${className || ""} whitespace-pre-wrap break-words`}
          href={href}
          onClick={onClick}
          passHref
          target="_blank"
        >
          {linkText ? linkText : href}
        </Link>
      )}
    </>
  );
}
